import { render, staticRenderFns } from "./PersonnelArchives.vue?vue&type=template&id=37941766&scoped=true&"
import script from "./PersonnelArchives.vue?vue&type=script&lang=js&"
export * from "./PersonnelArchives.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelArchives.vue?vue&type=style&index=0&id=37941766&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37941766",
  null
  
)

export default component.exports